module.exports = __webpack_public_path__ + "static/media/LinhaLab.26458175.pdf";